import { fetchWithToken } from '@hublot-io/core-api/client'
import config from '../utils/apiUtils'

export const NotilusService = {
  getTva(clientId) {
    return fetchWithToken(`${config().notilusService}/tva/${clientId}`, { method: 'GET' })
      .then((response) => response.json())
      .then((json) => json)
  },
  getVBO(clientId) {
    return fetchWithToken(`${config().notilusService}/vbo/${clientId}`, { method: 'GET' })
      .then((response) => response.json())
      .then((json) => json)
  },
  getBillPreferences(clientId) {
    return fetchWithToken(`${config().notilusService}/bill/${clientId}`, { method: 'GET' })
      .then((response) => response.json())
      .then((json) => json)
  },
  getEmployees(currentContext, clientId) {
    return fetchWithToken(`${config(currentContext).notilusService}/employees/${clientId}`, { method: 'GET' })
      .then((response) => response.json())
      .then((json) => json)
  },
  getCommandesSettings(clientId) {
    return fetchWithToken(`${config().notilusService}/commandes/${clientId}`, { method: 'GET' })
      .then((response) => response.json())
      .then((json) => json)
  },


}
